__webpack_require__.p = "/tokens-text-onboarding/referrals-hub/";